//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
import axios from 'axios'
import qs from 'qs'
export default {

	data() {
		return {
			model_selected: '',
			color_selected: '',
			size_selected: '',
			id : this.$store.state.post.id,
			title : this.$store.state.post.title ? this.$store.state.post.title.rendered : '',
			description : this.$store.state.post.acf.description,
			type : this.$store.state.post.acf.product_type,
			price : this.$store.state.post.acf.price,
			stock_print : this.$store.state.post.acf.stock_print,
			models : this.$store.state.post.acf.models,
			// design_pics : this.$store.state.post.acf.design_pics.sizes.medium,
			currency : 'EUR',
			envBaseUrlAdmin: process.env.envBaseUrlAdmin
		};
	},

	methods: {
		onChange(event) {
            console.log(event.target.value)
        },
        
        add_to_cart: function(){
        	console.log(process.env.envBaseUrlAdmin)
			var product = {}
			product.name = (this.type==='clothes') ? this.title + ' - '+this.model_selected+ ' - '+this.color_selected+ ' - '+this.size_selected : this.title
			product.description = document.getElementById('description').textContent
			product.price = this.price
			product.currency = this.currency
			product.quantity = 1
			product.sku = this.stock_print
			this.$store.commit('ADD_TO_CART',product)
			this.$store.dispatch('nav/openCart')
			var product = {}
			product.name = this.$t('shipping_fee')
			product.description = this.$t('shipping_mode')
			product.price = '14.00'
			product.currency = this.currency
			product.quantity = 1
			this.$store.commit('ADD_TO_CART',product)
			this.$store.dispatch('nav/openCart')
		}
	}
	
}
